<template>
    <div class="wrapper">
        <img src="../../assets/img/404.png" alt="">
    </div>
</template>

<script>
export default {

}
</script>

<style scoped lang='scss'>
.wrapper{
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
        width: 100%;
    }
}
</style>
